import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.CustomerDecisionSection.DeclineCustomerDecisionPopup', {
    popupTitle: 'Decline "{requestName}"',
    rejectButtonTitle: 'Decline quote',
    rejectButtonText: 'Decline',
    desciption:
        'Please provide a comment to let {authorName} as well as the Approvers know why the quote has been declined',
});
